import React, { useState } from "react";
import {
  Grid,
  Button,
  Segment
} from "semantic-ui-react";
import './Examples.css'
import { examples_data } from "../../../data/examples";
import { useSelector } from "react-redux";
import { getDatabases } from "../../../features/tableData/visualSlice";

const Examples = () => {
  const [examples, setExamples] = useState(true);
  const databases = useSelector(getDatabases);
  return (
    <>
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column width={4}></Grid.Column>
          <Grid.Column width={8}>
            <Button
              fluid
              onClick={() => {
                setExamples(!examples);
              }}
              className="top_margin"
            >
              Some examples to start with
            </Button>
          </Grid.Column>
          <Grid.Column width={4}></Grid.Column>
        </Grid.Row>
      {examples && 
        examples_data[databases[0].name].map((example, index) => {
          return (
            <Grid.Row columns={3}>
              <Grid.Column width={4}>
                </Grid.Column>
                <Grid.Column width={8}>
                  <Segment inverted className="wrap_message examples">
                    {example}
                  </Segment>
                  </Grid.Column>
              <Grid.Column width={4}>
              </Grid.Column>
              </Grid.Row>
          );
        })
      }
    </Grid>
    </>
  );
};

export default Examples;
